import { Avatar, Button, Col, Collapse, Form, Input, Row, Space, Table } from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import ModalDelete from 'components/tabel/ModalDelete';
import CreateCancel from 'components/forms/CreateCancel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import FormOrderFacility from './FormOrderFacility';
import InputControlAsync from 'components/inputs/InputControlAsync';
import InputControl from 'components/inputs/InputControl';

export default function OrderFacility() {
  const {
    handelAdd,
    handelEdit,
    accessPage,
    SohwaddFrom,
    urldashboard,
    authentication,
  } = useContext(DashboardContext);

  // table data
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState('');
  const [headers, setHeaders] = useState([]);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (!deleteModal) {
      getOrderFacilityInfo({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
        formData
      });
      setRowId('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, deleteModal]);

  const getOrderFacilityInfo = async ({ page, pageSize, searchValue, formData }) => {
    setLoading(true);
    try {
      let url = '/orderFacility/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue, ...formData }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getOrderFacilityInfo({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
      formData
    });
  };

  const search = () => {
    getOrderFacilityInfo({
      page: 1,
      pageSize: 10,
      searchValue,
      formData
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            {accessPage?.includes('Delete') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleDelete(record?.id)}
              >
                حذف
              </Dropdown.Item>
            )}
            {accessPage?.includes('Update') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleEditbtn(record?.id)}
              >
                ویرایش
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'عنوان',
      dataIndex: 'title',
      key: 'title',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'نوع',
      dataIndex: 'orderFacilityTypeTitle',
      key: 'orderFacilityTypeTitle',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'شرکت',
      dataIndex: 'companyName',
      key: 'companyName',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'هزینه',
      dataIndex: 'price',
      key: 'price',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>{value ? `${value.toLocaleString()} ریال` : '-'}</span>
      ),
    },
    {
      title: 'تاریخ شروع',
      dataIndex: 'fromDatePersianDate',
      key: 'fromDatePersianDate',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'تاریخ پایان',
      dataIndex: 'toDatePersianDate',
      key: 'toDatePersianDate',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
  ];

  const handleEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
  };

  const handleDelete = (id) => {
    setRowId(id);
    setDeleteModal(true);
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <CreateCancel />

      {SohwaddFrom ? (
        <div
          style={{
            padding: '20px',
            borderRadius: '10px',
            backgroundColor: '#ffff',
          }}
        >
          <FormOrderFacility />
        </div>
      ) : (
        <>

          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <Collapse defaultActiveKey={['0']}>
                <Collapse.Panel header='جستجو پیشرفته' key='1'>
                  {/* */}
                  <Row gutter={20} align={'middle'}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <InputControl
                        label='نوع زیرسیستم'
                        name='businessType'
                        url='/common/getSubSystemType'
                        handelValue={(_, value) => handleChange('businessType', value)}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      {formData?.businessType !== null && formData?.businessType !== undefined &&
                        <InputControlAsync
                          url={formData?.businessType ? '/userManagement/searchdropdown' : '/userManagement/B2BSearchDropDown'}
                          label='نام مشتری'
                          name='companyId'
                          handelValue={(_, value) => handleChange('companyId', value)}
                        />
                      }
                    </Col>
                  </Row>
                  {/* */}
                  <Row
                    gutter={20}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 20,
                    }}
                  >
                    <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                      <Button
                        type='primary'
                        style={{ width: '100%' }}
                        loading={loading}
                        onClick={() => search()}
                      >
                        جستجو
                      </Button>
                    </Col>
                  </Row>
                </Collapse.Panel>
              </Collapse>
            </div>
          </div>

          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Form form={form} layout='vertical' onFinish={search}>
                <InputGroup>
                  <Input
                    placeholder='جستجوی سریع (عنوان)'
                    name='searchValue'
                    onChange={(e) => setSearchValue(e.target.value)}
                    style={{
                      width: '90%',
                      height: '3rem',
                      display: 'table-cell',
                    }}
                  />
                  <Button
                    htmlType='submit'
                    style={{
                      padding: 0,
                      width: '10%',
                      height: '3rem',
                      display: 'table-cell',
                    }}
                  >
                    <i className='mdi mdi-magnify'></i>
                  </Button>
                </InputGroup>
              </Form>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel
                  data={data}
                  headers={headers}
                  fileName={'امکانات_اضافی_سفارش'}
                />
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}

          {deleteModal && (
            <ModalDelete
              showitem={deleteModal}
              handleCloseMoudal={() => setDeleteModal(false)}
              handeldeleteModal={() => setDeleteModal(false)}
              id={rowId}
            />
          )}
        </>
      )}
    </>
  );
}
